import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import surplusResourcesIcon from "../../../../../assets/new-product-detail-cats/sub-icons/prod-waste-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import {
  getProductSurplusResourceTotal,
  createSystemBoundaryProductSurplus,
} from "../../../../../apis/Product/ProductSurplusResourcesTotalApi";

const ProdSurplusResources = () => (
  <img
    src={surplusResourcesIcon}
    alt="Surplus Resources Icon"
    width={76}
    height={76}
  />
);

const ProdSurplusHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalProdItem, setTotalProdItem] = useState([]);
  const [systemBoundaryItem, setSystemBoundaryItem] = useState("");

  useEffect(() => {
    getProductSurplusResourceTotal({
      id: productId,
      setProdInv: setTotalProdItem,
      setSystemBoundary: setSystemBoundaryItem,
    });
  }, [productId]);
  return (
    <CategoryComponent
      show={show}
      className={`prod-surplus-category ${className || ""}`}
      leftBoxProps={{
        icon: <ProdSurplusResources />,
        title: t("WASTE"),
        description: t("SURPLUS_RESOURCE_INFO"),
        productId: productId,
        isSystemBoundary: true,
        systemBoundary: systemBoundaryItem,
        setSystemBoundary: setSystemBoundaryItem,
        createSystemBoundaryFunc: createSystemBoundaryProductSurplus,
        isManufacturing: true,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: t("EMISSIONS"),
                subitems: [
                  {
                    value: `${
                      totalProdItem
                        ? handleToFixedNum(
                            totalProdItem,
                            totalProdItem?.total_carbon
                          )
                        : "xx"
                    } (tCO₂e)`,
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default ProdSurplusHeader;
